import HeaderComponent from "../../components/headerComponent/HeaderComponent";
import HeaderContComponent from "../../components/headerContactComponent/HeaderContComponent";
import { Carousel } from "react-bootstrap";
import { useEffect, useMemo, useRef, useState } from "react";
import "./HomePageStyle.css";
import { db, whatsappLink } from "../../config/FirebaseConfig";
import { collection, getDocs } from "firebase/firestore";
import FooterComponent from "../../components/footerComponent/FooterComponent";
import Loader from "../../components/loader/Loader";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { openSupportChat, HIRE_MESSAGE } from "../../components/SupportChat/SupportChat";
import { SITE_URL } from "../../content/landingPages";
import {
  canonicalUrl,
  logoUrl,
  pageDescription,
  pageTitle,
  schemaLocalBusiness,
  schemaWebPage,
  schemaWebsite,
} from "../../content/homeSeo";
import FloatingNotification from "../../components/FloatingNotification/FloatingNotification";
import AppPromotionSection from "../../components/AppDownload/AppDownload";
import { ModalIndicouGanhou } from "../../components/ModalIndicouGanhou/modalIndicouGanhou";
import { ColourfulText } from "../../components/ColourfulText/ColourfulText";
import { Helmet } from "react-helmet-async";
import seoSitemapData from "../../content/seoSitemapData.json";
import { trackSiteAccess } from "../../services/accessTrackingService";
gsap.registerPlugin(ScrollTrigger);

const getBannerAlt = (banner, variant) => {
  const altFromData =
    banner?.altText ||
    banner?.alt ||
    banner?.title ||
    banner?.titulo ||
    banner?.name ||
    banner?.nome;
  if (altFromData) {
    return altFromData;
  }
  if (banner?.campanhaIndicouGanhou) {
    return variant === "mobile"
      ? "Banner mobile da campanha Indicou e Ganhou da Sette Fibra"
      : "Banner da campanha Indicou e Ganhou da Sette Fibra";
  }
  return variant === "mobile"
    ? "Banner mobile da Sette Fibra"
    : "Banner promocional da Sette Fibra";
};

const getCardAlt = (card, fallback) => {
  const altFromData =
    card?.altText ||
    card?.alt ||
    card?.title ||
    card?.titulo ||
    card?.name ||
    card?.nome ||
    card?.descricao ||
    card?.description;
  return altFromData || fallback;
};

const cityNetworkNodes = [
  { slug: "planalmira", x: 66, y: 12, labelX: 0, labelY: -40 },
  { slug: "abadiania", x: 79, y: 30, labelX: 40, labelY: -8 },
  { slug: "campo-limpo-de-goias", x: 31, y: 37, labelX: -6, labelY: -34 },
  { slug: "anapolis", x: 56, y: 44, labelX: 0, labelY: 16 },
  { slug: "neropolis", x: 16, y: 58, labelX: -38, labelY: -10 },
  { slug: "terezopolis-de-goias", x: 31, y: 69, labelX: 0, labelY: 12 },
  { slug: "goianapolis", x: 47, y: 74, labelX: 38, labelY: 10 },
  { slug: "senador-canedo", x: 32, y: 88, labelX: 18, labelY: 10 },
  { slug: "corumba-de-goias", x: 9, y: 33, labelX: 44, labelY: -6 },
  { slug: "posse-d-abadia", x: 11, y: 81, labelX: 40, labelY: -6 },
  { slug: "brasilia", x: 82, y: 63, labelX: -30, labelY: -10 },
];

const cityNetworkLinks = [
  { from: "anapolis", to: "planalmira", cx: 75, cy: 18 },
  { from: "anapolis", to: "abadiania", cx: 71, cy: 40 },
  { from: "anapolis", to: "campo-limpo-de-goias", cx: 44, cy: 34 },
  { from: "campo-limpo-de-goias", to: "neropolis", cx: 20, cy: 46 },
  { from: "anapolis", to: "terezopolis-de-goias", cx: 21, cy: 66 },
  { from: "anapolis", to: "goianapolis", cx: 39, cy: 77 },
  { from: "goianapolis", to: "senador-canedo", cx: 39, cy: 84 },
  { from: "campo-limpo-de-goias", to: "corumba-de-goias", cx: 17, cy: 29 },
  { from: "terezopolis-de-goias", to: "posse-d-abadia", cx: 27, cy: 83 },
  { from: "anapolis", to: "brasilia", cx: 72, cy: 52 },
];

const cityNetworkMobileLabelOffsets = {
  planalmira: { labelXMobile: 0, labelYMobile: -10 },
  abadiania: { labelXMobile: 16, labelYMobile: -8 },
  "campo-limpo-de-goias": { labelXMobile: 18, labelYMobile: -10 },
  anapolis: { labelXMobile: 0, labelYMobile: 40 },
  neropolis: { labelXMobile: 10, labelYMobile: -6 },
  "terezopolis-de-goias": { labelXMobile: 6, labelYMobile: -8 },
  goianapolis: { labelXMobile: 10, labelYMobile: -8 },
  "senador-canedo": { labelXMobile: 14, labelYMobile: -12 },
  "corumba-de-goias": { labelXMobile: 15, labelYMobile: -10 },
  "posse-d-abadia": { labelXMobile: 10, labelYMobile: -8 },
  brasilia: { labelXMobile: -14, labelYMobile: -10 },
};

const cityNetworkSeoLabelsBySlug = {
  anapolis:
    "Internet fibra Óptica em Anápolis com alta velocidade e estabilidade",
  brasilia: "Provedor de internet fibra óptica em Brasília com baixa latência",
};

const getCityNetworkSeoLabel = (node) =>
  cityNetworkSeoLabelsBySlug[node.slug] ||
  `Internet fibra Óptica em ${node.city.name} com alta velocidade, estabilidade e baixa latência`;

const CITY_NETWORK_HUB_SLUG = "anapolis";

const getCityNetworkConnectionKey = (fromSlug, toSlug) =>
  [fromSlug, toSlug].sort().join("::");

const getQuadraticBezierPoint = (curve, progress) => {
  const clampedProgress = Math.min(Math.max(progress, 0), 1);
  const inverse = 1 - clampedProgress;
  return {
    x:
      inverse * inverse * curve.startX +
      2 * inverse * clampedProgress * curve.controlX +
      clampedProgress * clampedProgress * curve.endX,
    y:
      inverse * inverse * curve.startY +
      2 * inverse * clampedProgress * curve.controlY +
      clampedProgress * clampedProgress * curve.endY,
  };
};

const cityNetworkPerfProfiles = {
  desktop: {
    visibleLaneIndexes: [0, 1, 2, 3, 4, 5, 6],
    animatedLaneIndexes: [1, 3, 5],
    particleLaneIndexes: [3],
    fps: 36,
    dprCap: 1,
    dimmedLinkAlpha: 0.16,
    idleLinkAlpha: 0.74,
  },
  balanced: {
    visibleLaneIndexes: [1, 2, 3, 4],
    animatedLaneIndexes: [2, 3],
    particleLaneIndexes: [3],
    fps: 34,
    dprCap: 1,
    dimmedLinkAlpha: 0.14,
    idleLinkAlpha: 0.68,
  },
  compact: {
    visibleLaneIndexes: [1, 2, 3, 4],
    animatedLaneIndexes: [2, 3],
    particleLaneIndexes: [],
    fps: 24,
    dprCap: 1,
    dimmedLinkAlpha: 0.12,
    idleLinkAlpha: 0.66,
  },
  reduced: {
    visibleLaneIndexes: [3],
    animatedLaneIndexes: [],
    particleLaneIndexes: [],
    fps: 12,
    dprCap: 1,
    dimmedLinkAlpha: 0.16,
    idleLinkAlpha: 0.62,
  },
};

const fiberThreadProfiles = [
  {
    id: "lane-1",
    offset: -0.96,
    curveX: -0.52,
    curveY: 0.14,
    flowDuration: 2.3,
    flowDelay: 0.18,
    flowDash: "0.026 0.13",
    flowOpacity: 0.65,
    reverse: false,
    particleDuration: 4.1,
    particleDelay: 0.42,
    particleRadius: 0.1,
  },
  {
    id: "lane-2",
    offset: -0.64,
    curveX: 0.2,
    curveY: -0.22,
    flowDuration: 2.95,
    flowDelay: 0.42,
    flowDash: "0.031 0.155",
    flowOpacity: 0.72,
    reverse: true,
    particleDuration: 3.8,
    particleDelay: 0.95,
    particleRadius: 0.12,
  },
  {
    id: "lane-3",
    offset: -0.32,
    curveX: -0.12,
    curveY: 0.28,
    flowDuration: 2.6,
    flowDelay: 0.07,
    flowDash: "0.024 0.118",
    flowOpacity: 0.6,
    reverse: false,
    particleDuration: 4.45,
    particleDelay: 0.58,
    particleRadius: 0.09,
  },
  {
    id: "lane-4",
    offset: 0,
    curveX: 0,
    curveY: 0,
    flowDuration: 2.15,
    flowDelay: 0.31,
    flowDash: "0.036 0.14",
    flowOpacity: 0.82,
    reverse: false,
    particleDuration: 3.4,
    particleDelay: 0.24,
    particleRadius: 0.14,
  },
  {
    id: "lane-5",
    offset: 0.32,
    curveX: 0.15,
    curveY: -0.26,
    flowDuration: 2.75,
    flowDelay: 0.54,
    flowDash: "0.028 0.124",
    flowOpacity: 0.68,
    reverse: true,
    particleDuration: 4.25,
    particleDelay: 1.02,
    particleRadius: 0.1,
  },
  {
    id: "lane-6",
    offset: 0.64,
    curveX: -0.26,
    curveY: 0.23,
    flowDuration: 3.1,
    flowDelay: 0.12,
    flowDash: "0.033 0.16",
    flowOpacity: 0.74,
    reverse: false,
    particleDuration: 3.9,
    particleDelay: 0.68,
    particleRadius: 0.11,
  },
  {
    id: "lane-7",
    offset: 0.96,
    curveX: 0.45,
    curveY: -0.16,
    flowDuration: 2.45,
    flowDelay: 0.66,
    flowDash: "0.023 0.112",
    flowOpacity: 0.62,
    reverse: true,
    particleDuration: 4.5,
    particleDelay: 1.24,
    particleRadius: 0.09,
  },
];

const buildFiberThreadCurve = (
  fromNode,
  toNode,
  controlPoint,
  threadProfile,
) => {
  const deltaX = toNode.x - fromNode.x;
  const deltaY = toNode.y - fromNode.y;
  const distance = Math.hypot(deltaX, deltaY) || 1;
  const normalX = -deltaY / distance;
  const normalY = deltaX / distance;
  const laneOffset = threadProfile.offset;

  const startX = fromNode.x + normalX * laneOffset;
  const startY = fromNode.y + normalY * laneOffset;
  const endX = toNode.x + normalX * laneOffset;
  const endY = toNode.y + normalY * laneOffset;
  const controlX =
    controlPoint.cx + normalX * laneOffset * 1.3 + threadProfile.curveX;
  const controlY =
    controlPoint.cy + normalY * laneOffset * 1.3 + threadProfile.curveY;

  return {
    startX,
    startY,
    controlX,
    controlY,
    endX,
    endY,
    d: `M ${startX} ${startY} Q ${controlX} ${controlY} ${endX} ${endY}`,
  };
};

const buildFiberThreadPath = (fromNode, toNode, controlPoint, threadProfile) =>
  buildFiberThreadCurve(fromNode, toNode, controlPoint, threadProfile).d;

export default function HomePage() {
  const [index, setIndex] = useState(0);
  const [panel1, setPanel1] = useState([]);
  const [panel2, setPanel2] = useState([]);
  const [panel3, setPanel3] = useState([]);
  const [panel4, setPanel4] = useState([]);
  const [carousel, setCarousel] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [isCitiesNetworkInView, setIsCitiesNetworkInView] = useState(false);
  const [isCitiesNetworkCompact, setIsCitiesNetworkCompact] = useState(false);
  const [citiesNetworkPerfMode, setCitiesNetworkPerfMode] = useState("desktop");
  const [isCitiesNetworkPageVisible, setIsCitiesNetworkPageVisible] =
    useState(true);
  const [isCitiesNetworkUseCanvas, setIsCitiesNetworkUseCanvas] =
    useState(false);
  const [selectedCitySlug, setSelectedCitySlug] = useState("anapolis");
  const [showIndicouGanhouModal, setShowIndicouGanhouModal] = useState(false);
  const [currentPanel, setCurrentPanel] = useState(null);
  const schemaLocalBusinessJson = JSON.stringify(schemaLocalBusiness);
  const schemaWebsiteJson = JSON.stringify(schemaWebsite);
  const schemaWebPageJson = JSON.stringify(schemaWebPage);
  const googleReviewsUrl =
    "https://www.google.com/search?q=Sette+Fibra+Anapolis";

  const cityBySlug = useMemo(
    () =>
      seoSitemapData.cities.reduce((accumulator, city) => {
        accumulator[city.slug] = city;
        return accumulator;
      }, {}),
    [],
  );

  const servedCities = useMemo(
    () =>
      cityNetworkNodes
        .map((node) => {
          const city = cityBySlug[node.slug];
          if (!city) {
            return null;
          }
          return {
            ...node,
            ...(cityNetworkMobileLabelOffsets[node.slug] || {}),
            city,
          };
        })
        .filter(Boolean),
    [cityBySlug],
  );

  const servedCityBySlug = useMemo(
    () =>
      servedCities.reduce((accumulator, node) => {
        accumulator[node.slug] = node;
        return accumulator;
      }, {}),
    [servedCities],
  );

  const cityNetworkRoutesBySlug = useMemo(() => {
    const adjacencyBySlug = {};
    cityNetworkLinks.forEach((link) => {
      const key = getCityNetworkConnectionKey(link.from, link.to);
      if (!adjacencyBySlug[link.from]) {
        adjacencyBySlug[link.from] = [];
      }
      if (!adjacencyBySlug[link.to]) {
        adjacencyBySlug[link.to] = [];
      }
      adjacencyBySlug[link.from].push({
        nextSlug: link.to,
        connectionKey: key,
      });
      adjacencyBySlug[link.to].push({
        nextSlug: link.from,
        connectionKey: key,
      });
    });

    const queue = [CITY_NETWORK_HUB_SLUG];
    const visited = new Set([CITY_NETWORK_HUB_SLUG]);
    const routeBySlug = {
      [CITY_NETWORK_HUB_SLUG]: {
        nodePath: [CITY_NETWORK_HUB_SLUG],
        connectionPath: [],
      },
    };

    while (queue.length) {
      const currentSlug = queue.shift();
      const currentRoute = routeBySlug[currentSlug];
      (adjacencyBySlug[currentSlug] || []).forEach(
        ({ nextSlug, connectionKey }) => {
          if (visited.has(nextSlug)) {
            return;
          }
          visited.add(nextSlug);
          routeBySlug[nextSlug] = {
            nodePath: [...currentRoute.nodePath, nextSlug],
            connectionPath: [...currentRoute.connectionPath, connectionKey],
          };
          queue.push(nextSlug);
        },
      );
    }

    return routeBySlug;
  }, []);

  const selectedCityRoute = useMemo(
    () =>
      cityNetworkRoutesBySlug[selectedCitySlug] || {
        nodePath: [selectedCitySlug],
        connectionPath: [],
      },
    [cityNetworkRoutesBySlug, selectedCitySlug],
  );

  const selectedCityRouteConnectionKeySet = useMemo(
    () => new Set(selectedCityRoute.connectionPath || []),
    [selectedCityRoute],
  );

  const selectedCityRouteNodeSet = useMemo(
    () => new Set(selectedCityRoute.nodePath || []),
    [selectedCityRoute],
  );

  const citiesNetworkPerfProfile = useMemo(
    () =>
      cityNetworkPerfProfiles[citiesNetworkPerfMode] ||
      cityNetworkPerfProfiles.desktop,
    [citiesNetworkPerfMode],
  );

  const schemaInternetService = useMemo(
    () => ({
      "@context": "https://schema.org",
      "@type": "Service",
      "@id": `${SITE_URL}/#fiber-service`,
      name: "Internet fibra óptica SETTE Fibra em Goiás e região",
      serviceType:
        "Provedor de internet fibra óptica residencial e empresarial",
      provider: { "@id": `${SITE_URL}/#organization` },
      areaServed: [
        {
          "@type": "AdministrativeArea",
          name: "Goiás",
          sameAs: "https://www.wikidata.org/wiki/Q41587",
        },
        {
          "@type": "AdministrativeArea",
          name: "Distrito Federal",
          sameAs: "https://www.wikidata.org/wiki/Q119158",
        },
        ...servedCities.map((node) => ({
          "@type": "City",
          name: node.city.name,
          address: {
            "@type": "PostalAddress",
            addressRegion: node.city.state || "GO",
            addressCountry: "BR",
          },
        })),
      ],
      availableChannel: {
        "@type": "ServiceChannel",
        serviceUrl: canonicalUrl,
        servicePhone: "+55 62 4051-9377",
      },
      offers: {
        "@type": "Offer",
        url: canonicalUrl,
        category: "internet fibra óptica",
        availability: "https://schema.org/InStock",
      },
      audience: {
        "@type": "Audience",
        audienceType: ["Residencial", "Empresarial"],
      },
    }),
    [servedCities],
  );

  const schemaInternetServiceJson = JSON.stringify(schemaInternetService);

  const trackCitiesNetworkInteraction = (action, details = {}) => {
    if (typeof window === "undefined") {
      return;
    }

    const payload = {
      event_category: "cities_network",
      event_label: details.cityName || details.slug || "unknown",
      interaction_source: details.source,
      city_slug: details.slug,
      city_name: details.cityName,
      selected_city_slug: selectedCitySlug,
      route_length: selectedCityRoute.connectionPath.length,
      perf_mode: citiesNetworkPerfMode,
      ...details,
    };

    try {
      if (typeof window.gtag === "function") {
        window.gtag("event", action, payload);
      }
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({
          event: "cities_network_interaction",
          action,
          ...payload,
        });
      }
      if (typeof window.fbq === "function") {
        window.fbq("trackCustom", "CitiesNetworkInteraction", {
          action,
          city_slug: payload.city_slug,
          city_name: payload.city_name,
          source: payload.interaction_source,
          perf_mode: payload.perf_mode,
        });
      }
    } catch (error) {
      console.warn("Cities network tracking error:", error);
    }
  };

  const handleCitiesNetworkSelectCity = (slug, source) => {
    setSelectedCitySlug(slug);
    const selectedNode = servedCityBySlug[slug];
    const selectedRouteForSlug = cityNetworkRoutesBySlug[slug];
    trackCitiesNetworkInteraction("select_city", {
      source,
      slug,
      cityName: selectedNode?.city?.name,
      route_length: selectedRouteForSlug?.connectionPath?.length || 0,
    });
  };

  const carouselRef = useRef(null);
  const plansTitleRef = useRef(null);
  const plansCardsRef = useRef(null);
  const lancamentosTitleRef = useRef(null);
  const lancamentosCardsRef = useRef(null);
  const vantagensTitleRef = useRef(null);
  const vantagensCardsRef = useRef(null);
  const citiesNetworkRef = useRef(null);
  const citiesNetworkMapRef = useRef(null);
  const citiesNetworkCanvasRef = useRef(null);
  const bgElementsRef = useRef([]);

  const isCitiesNetworkPlaying =
    isCitiesNetworkInView && isCitiesNetworkPageVisible;
  const isCitiesNetworkCanvasEnabled = isCitiesNetworkUseCanvas;

  const citiesNetworkConnectionsRenderData = useMemo(
    () =>
      cityNetworkLinks
        .map((connection) => {
          const fromNode = servedCityBySlug[connection.from];
          const toNode = servedCityBySlug[connection.to];
          if (!fromNode || !toNode) {
            return null;
          }

          const connectionKey = `${connection.from}-${connection.to}`;
          const canonicalKey = getCityNetworkConnectionKey(
            connection.from,
            connection.to,
          );
          const threads = fiberThreadProfiles.map((threadProfile) => ({
            threadProfile,
            curve: buildFiberThreadCurve(
              fromNode,
              toNode,
              connection,
              threadProfile,
            ),
          }));

          return {
            ...connection,
            connectionKey,
            canonicalKey,
            fromNode,
            toNode,
            isOnSelectedRoute:
              selectedCityRouteConnectionKeySet.has(canonicalKey),
            threads,
          };
        })
        .filter(Boolean),
    [servedCityBySlug, selectedCityRouteConnectionKeySet],
  );

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  useEffect(() => {
    setLoading(true);
    trackSiteAccess();

    const getPanels = async () => {
      const data = await getDocs(collection(db, "panels"));
      setPanel1(
        data.docs
          .map((doc) => ({ ...doc.data(), id: doc.id }))
          .filter((panel) => panel.panel === 1)
          .sort((a, b) => a.card - b.card),
      );
      setPanel2(
        data.docs
          .map((doc) => ({ ...doc.data(), id: doc.id }))
          .filter((panel) => panel.panel === 2)
          .sort((a, b) => a.card - b.card),
      );
      setPanel3(
        data.docs
          .map((doc) => ({ ...doc.data(), id: doc.id }))
          .filter((panel) => panel.panel === 3)
          .sort((a, b) => a.card - b.card),
      );
      setPanel4(
        data.docs
          .map((doc) => ({ ...doc.data(), id: doc.id }))
          .filter((panel) => panel.panel === 4)
          .sort((a, b) => a.card - b.card),
      );
    };

    const getCarousel = async () => {
      try {
        const carouselCollection = collection(db, "carousel");
        const data = await getDocs(carouselCollection);
        const carouselData = data.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }));
        setCarousel(carouselData);
      } catch (error) {
        console.error("Error loading carousel:", error);
      } finally {
        // Sai assim que os banners chegam (antes esperava +1s); com erro também sai.
        setLoading(false);
      }
    };

    getPanels();
    getCarousel();
  }, []);

  useEffect(() => {
    if (!isLoading && carousel.length > 0) {
      initAnimations();
    }
  }, [isLoading, carousel]);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) {
      return undefined;
    }

    const viewportQuery = window.matchMedia("(max-width: 768px)");
    const laptopQuery = window.matchMedia("(max-width: 1366px)");
    const motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

    const updateCompactMode = () => {
      const isReducedMotion = motionQuery.matches;
      const isCompactViewport = viewportQuery.matches;
      const isLaptopViewport = laptopQuery.matches;
      const deviceMemory =
        typeof navigator !== "undefined" && navigator.deviceMemory
          ? navigator.deviceMemory
          : 8;
      const cpuCores =
        typeof navigator !== "undefined" && navigator.hardwareConcurrency
          ? navigator.hardwareConcurrency
          : 8;
      const shouldUseBalancedMode =
        isLaptopViewport || deviceMemory <= 4 || cpuCores <= 4;

      setIsCitiesNetworkCompact(isCompactViewport || isReducedMotion);
      setCitiesNetworkPerfMode(
        isReducedMotion
          ? "reduced"
          : isCompactViewport
            ? "compact"
            : shouldUseBalancedMode
              ? "balanced"
              : "desktop",
      );
    };

    updateCompactMode();

    if (viewportQuery.addEventListener) {
      viewportQuery.addEventListener("change", updateCompactMode);
      laptopQuery.addEventListener("change", updateCompactMode);
      motionQuery.addEventListener("change", updateCompactMode);
      window.addEventListener("resize", updateCompactMode, { passive: true });
      return () => {
        viewportQuery.removeEventListener("change", updateCompactMode);
        laptopQuery.removeEventListener("change", updateCompactMode);
        motionQuery.removeEventListener("change", updateCompactMode);
        window.removeEventListener("resize", updateCompactMode);
      };
    }

    viewportQuery.addListener(updateCompactMode);
    laptopQuery.addListener(updateCompactMode);
    motionQuery.addListener(updateCompactMode);
    window.addEventListener("resize", updateCompactMode);
    return () => {
      viewportQuery.removeListener(updateCompactMode);
      laptopQuery.removeListener(updateCompactMode);
      motionQuery.removeListener(updateCompactMode);
      window.removeEventListener("resize", updateCompactMode);
    };
  }, []);

  useEffect(() => {
    if (typeof document === "undefined") {
      return undefined;
    }

    const handleVisibilityChange = () => {
      setIsCitiesNetworkPageVisible(!document.hidden);
    };

    handleVisibilityChange();
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  useEffect(() => {
    if (typeof document === "undefined") {
      return undefined;
    }

    const canvasElement = document.createElement("canvas");
    const context = canvasElement.getContext("2d");
    setIsCitiesNetworkUseCanvas(Boolean(context));
    return undefined;
  }, []);

  useEffect(() => {
    const sectionElement = citiesNetworkRef.current;
    if (!sectionElement || typeof IntersectionObserver === "undefined") {
      setIsCitiesNetworkInView(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        setIsCitiesNetworkInView(entry.isIntersecting);
      },
      {
        threshold: 0,
        rootMargin: "100px 0px 100px 0px",
      },
    );

    observer.observe(sectionElement);

    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    if (!isCitiesNetworkCanvasEnabled) {
      return undefined;
    }

    const mapElement = citiesNetworkMapRef.current;
    const canvasElement = citiesNetworkCanvasRef.current;
    if (!mapElement || !canvasElement) {
      return undefined;
    }

    const context = canvasElement.getContext("2d", { alpha: true });
    if (!context) {
      return undefined;
    }

    const hasFocusedRoute =
      Boolean(selectedCitySlug) && selectedCitySlug !== CITY_NETWORK_HUB_SLUG;
    const visibleLaneIndexSet = new Set(
      citiesNetworkPerfProfile.visibleLaneIndexes,
    );
    const animatedLaneIndexSet = new Set(
      citiesNetworkPerfProfile.animatedLaneIndexes,
    );
    const particleLaneIndexSet = new Set(
      citiesNetworkPerfProfile.particleLaneIndexes,
    );
    const laneScale =
      citiesNetworkPerfMode === "desktop"
        ? 1
        : citiesNetworkPerfMode === "balanced"
          ? 0.95
          : 0.9;

    let disposed = false;
    let animationFrameId = 0;
    let resizeObserver = null;
    let fallbackResizeHandler = null;
    let width = 0;
    let height = 0;
    let dpr = 1;
    let lastFrameTimestamp = 0;
    let animationStartTimestamp = 0;
    const staticLayerCanvas = document.createElement("canvas");
    const staticLayerContext = staticLayerCanvas.getContext("2d", {
      alpha: true,
    });

    const drawQuadraticCurve = (targetContext, curve) => {
      targetContext.beginPath();
      targetContext.moveTo(
        (curve.startX / 100) * width,
        (curve.startY / 100) * height,
      );
      targetContext.quadraticCurveTo(
        (curve.controlX / 100) * width,
        (curve.controlY / 100) * height,
        (curve.endX / 100) * width,
        (curve.endY / 100) * height,
      );
    };

    const getBaseVisibilityAlpha = (isRouteConnection) =>
      hasFocusedRoute
        ? isRouteConnection
          ? 1
          : citiesNetworkPerfProfile.dimmedLinkAlpha
        : citiesNetworkPerfProfile.idleLinkAlpha;

    const drawStaticLayer = () => {
      if (!staticLayerContext) {
        return;
      }

      staticLayerContext.clearRect(0, 0, width, height);
      staticLayerContext.lineCap = "round";
      staticLayerContext.lineJoin = "round";

      citiesNetworkConnectionsRenderData.forEach((connection) => {
        const isRouteConnection = connection.isOnSelectedRoute;
        const baseVisibilityAlpha = getBaseVisibilityAlpha(isRouteConnection);
        connection.threads.forEach(({ curve }, threadIndex) => {
          if (!visibleLaneIndexSet.has(threadIndex)) {
            return;
          }

          const glowWidth = (isRouteConnection ? 2.4 : 1.45) * laneScale;
          const lineWidth = (isRouteConnection ? 1.1 : 0.72) * laneScale;
          const glowAlpha =
            (isRouteConnection ? 0.26 : 0.14) * baseVisibilityAlpha;
          const lineAlpha =
            (isRouteConnection ? 0.72 : 0.42) * baseVisibilityAlpha;

          staticLayerContext.save();
          drawQuadraticCurve(staticLayerContext, curve);
          staticLayerContext.strokeStyle = `rgba(${
            isRouteConnection ? "116, 228, 255" : "95, 209, 255"
          }, ${glowAlpha})`;
          staticLayerContext.lineWidth = glowWidth;
          staticLayerContext.shadowBlur = isRouteConnection ? 14 : 9;
          staticLayerContext.shadowColor = isRouteConnection
            ? "rgba(116, 228, 255, 0.28)"
            : "rgba(95, 209, 255, 0.16)";
          staticLayerContext.stroke();
          staticLayerContext.restore();

          staticLayerContext.save();
          drawQuadraticCurve(staticLayerContext, curve);
          staticLayerContext.strokeStyle = `rgba(164, 231, 255, ${lineAlpha})`;
          staticLayerContext.lineWidth = lineWidth;
          staticLayerContext.stroke();
          staticLayerContext.restore();
        });
      });
    };

    const resizeCanvas = () => {
      const rect = mapElement.getBoundingClientRect();
      width = Math.max(1, Math.round(rect.width));
      height = Math.max(1, Math.round(rect.height));
      dpr = Math.min(
        typeof window !== "undefined" ? window.devicePixelRatio || 1 : 1,
        citiesNetworkPerfProfile.dprCap,
      );

      canvasElement.width = Math.round(width * dpr);
      canvasElement.height = Math.round(height * dpr);
      canvasElement.style.width = `${width}px`;
      canvasElement.style.height = `${height}px`;
      context.setTransform(dpr, 0, 0, dpr, 0, 0);
      if (staticLayerContext) {
        staticLayerCanvas.width = Math.round(width * dpr);
        staticLayerCanvas.height = Math.round(height * dpr);
        staticLayerContext.setTransform(dpr, 0, 0, dpr, 0, 0);
        drawStaticLayer();
      }
    };

    const renderFrame = (timestamp) => {
      if (disposed) {
        return;
      }

      if (!animationStartTimestamp) {
        animationStartTimestamp = timestamp;
      }

      const frameInterval = 1000 / citiesNetworkPerfProfile.fps;
      if (
        isCitiesNetworkPlaying &&
        lastFrameTimestamp &&
        timestamp - lastFrameTimestamp < frameInterval
      ) {
        animationFrameId = window.requestAnimationFrame(renderFrame);
        return;
      }
      lastFrameTimestamp = timestamp;

      if (!width || !height) {
        resizeCanvas();
      }

      context.clearRect(0, 0, width, height);
      context.lineCap = "round";
      context.lineJoin = "round";
      if (staticLayerContext) {
        context.drawImage(staticLayerCanvas, 0, 0, width, height);
      }

      const elapsedSeconds = (timestamp - animationStartTimestamp) / 1000;

      citiesNetworkConnectionsRenderData.forEach(
        (connection, connectionIndex) => {
          const isRouteConnection = connection.isOnSelectedRoute;
          const baseVisibilityAlpha = getBaseVisibilityAlpha(isRouteConnection);

          connection.threads.forEach(
            ({ threadProfile, curve }, threadIndex) => {
              if (!visibleLaneIndexSet.has(threadIndex)) {
                return;
              }

              const flowWidth = (isRouteConnection ? 1.35 : 0.9) * laneScale;

              const shouldAnimateLane =
                isCitiesNetworkPlaying && animatedLaneIndexSet.has(threadIndex);
              const shouldDrawParticle =
                isCitiesNetworkPlaying && particleLaneIndexSet.has(threadIndex);

              if (!shouldAnimateLane && !shouldDrawParticle) {
                return;
              }

              if (shouldAnimateLane) {
                const speedPx =
                  (40 / Math.max(threadProfile.flowDuration, 1.1)) *
                  (isRouteConnection ? 1.18 : 1);
                const dashLength =
                  5 + (threadIndex % 3) * 1.5 + (isRouteConnection ? 1.4 : 0);
                const gapLength =
                  13 + (connectionIndex % 4) * 1.6 + (threadIndex % 2) * 1.1;
                const direction = threadProfile.reverse ? -1 : 1;
                const dashOffset =
                  (elapsedSeconds + threadProfile.flowDelay) *
                  speedPx *
                  direction;

                context.save();
                drawQuadraticCurve(context, curve);
                context.lineWidth = flowWidth;
                context.strokeStyle = isRouteConnection
                  ? `rgba(244, 252, 255, ${
                      Math.min(threadProfile.flowOpacity + 0.2, 0.98) *
                      baseVisibilityAlpha
                    })`
                  : `rgba(220, 250, 255, ${
                      threadProfile.flowOpacity * 0.82 * baseVisibilityAlpha
                    })`;
                context.setLineDash([dashLength, gapLength]);
                context.lineDashOffset = -dashOffset;
                context.shadowBlur = isRouteConnection ? 6 : 3;
                context.shadowColor = isRouteConnection
                  ? "rgba(244, 252, 255, 0.35)"
                  : "rgba(215, 250, 255, 0.18)";
                context.stroke();
                context.restore();
                context.setLineDash([]);
              }

              if (shouldDrawParticle) {
                const particleDuration =
                  threadProfile.particleDuration + (connectionIndex % 3) * 0.2;
                const particlePhase = threadProfile.reverse
                  ? 1 -
                    (((((elapsedSeconds + threadProfile.particleDelay) /
                      particleDuration) %
                      1) +
                      1) %
                      1)
                  : ((((elapsedSeconds + threadProfile.particleDelay) /
                      particleDuration) %
                      1) +
                      1) %
                    1;
                const point = getQuadraticBezierPoint(curve, particlePhase);
                const particleRadius = isRouteConnection ? 2.4 : 1.8;

                context.save();
                context.beginPath();
                context.arc(
                  (point.x / 100) * width,
                  (point.y / 100) * height,
                  particleRadius,
                  0,
                  Math.PI * 2,
                );
                context.fillStyle = isRouteConnection
                  ? `rgba(255, 247, 221, ${0.95 * baseVisibilityAlpha})`
                  : `rgba(236, 252, 255, ${0.78 * baseVisibilityAlpha})`;
                context.shadowBlur = isRouteConnection ? 10 : 5;
                context.shadowColor = isRouteConnection
                  ? "rgba(245, 183, 73, 0.32)"
                  : "rgba(115, 224, 255, 0.22)";
                context.fill();
                context.restore();
              }
            },
          );
        },
      );

      if (isCitiesNetworkPlaying) {
        animationFrameId = window.requestAnimationFrame(renderFrame);
      }
    };

    const kickRender = () => {
      if (disposed) {
        return;
      }
      if (animationFrameId) {
        window.cancelAnimationFrame(animationFrameId);
      }
      lastFrameTimestamp = 0;
      animationFrameId = window.requestAnimationFrame(renderFrame);
    };

    resizeCanvas();
    kickRender();

    if (typeof ResizeObserver !== "undefined") {
      resizeObserver = new ResizeObserver(() => {
        resizeCanvas();
        kickRender();
      });
      resizeObserver.observe(mapElement);
    } else if (typeof window !== "undefined") {
      fallbackResizeHandler = () => {
        resizeCanvas();
        kickRender();
      };
      window.addEventListener("resize", fallbackResizeHandler);
    }

    return () => {
      disposed = true;
      if (animationFrameId) {
        window.cancelAnimationFrame(animationFrameId);
      }
      if (resizeObserver) {
        resizeObserver.disconnect();
      } else if (
        typeof window !== "undefined" &&
        typeof fallbackResizeHandler === "function"
      ) {
        window.removeEventListener("resize", fallbackResizeHandler);
      }
      context.clearRect(0, 0, width, height);
      if (staticLayerContext) {
        staticLayerContext.clearRect(0, 0, width, height);
      }
    };
  }, [
    citiesNetworkConnectionsRenderData,
    citiesNetworkPerfMode,
    citiesNetworkPerfProfile,
    isCitiesNetworkPlaying,
    isCitiesNetworkCanvasEnabled,
    selectedCitySlug,
  ]);

  const initAnimations = () => {
    gsap.from(carouselRef.current, {
      opacity: 0,
      y: 50,
      duration: 1,
      ease: "sine.inOut",
    });

    gsap.from(plansTitleRef.current, {
      scrollTrigger: {
        trigger: plansTitleRef.current,
        start: "top 99%",
        toggleActions: "play none none none",
      },
      opacity: 0,
      y: 30,
      duration: 0.8,
      ease: "power2.out",
    });

    gsap.from(plansCardsRef.current.children, {
      scrollTrigger: {
        trigger: plansCardsRef.current,
        start: "top 90%",
        toggleActions: "play none none none",
      },
      opacity: 0,
      y: 50,
      duration: 0.6,
      stagger: 0.1,
      ease: "back.out",
    });

    gsap.from(lancamentosTitleRef.current, {
      scrollTrigger: {
        trigger: lancamentosTitleRef.current,
        start: "top 80%",
        toggleActions: "play none none none",
      },
      opacity: 0,
      y: 30,
      duration: 0.8,
      ease: "power2.out",
    });

    gsap.from(lancamentosCardsRef.current.children, {
      scrollTrigger: {
        trigger: lancamentosCardsRef.current,
        start: "top 80%",
        toggleActions: "play none none none",
      },
      opacity: 0,
      y: 50,
      duration: 0.6,
      stagger: 0.1,
      ease: "back.out",
    });

    gsap.from(vantagensTitleRef.current, {
      scrollTrigger: {
        trigger: vantagensTitleRef.current,
        start: "top 80%",
        toggleActions: "play none none none",
      },
      opacity: 0,
      y: 30,
      duration: 0.8,
      ease: "power2.out",
    });

    gsap.from(vantagensCardsRef.current.children, {
      scrollTrigger: {
        trigger: vantagensCardsRef.current,
        start: "top 80%",
        toggleActions: "play none none none",
      },
      opacity: 0,
      y: 50,
      duration: 0.6,
      stagger: 0.15,
      ease: "back.out",
    });

    gsap.from(bgElementsRef.current, {
      scrollTrigger: {
        trigger: ".content",
        start: "top center",
        toggleActions: "play none none none",
      },
      opacity: 0,
      y: 30,
      duration: 1,
      stagger: 0.2,
      ease: "sine.out",
    });

    const cards = document.querySelectorAll(".plan-card, .plan-card-vantagens");
    cards.forEach((card) => {
      card.addEventListener("mouseenter", () => {
        gsap.to(card, {
          scale: 1.03,
          duration: 0.3,
          ease: "power2.out",
        });
      });
      card.addEventListener("mouseleave", () => {
        gsap.to(card, {
          scale: 1,
          duration: 0.3,
          ease: "power2.out",
        });
      });
    });
  };

  // Card clicável: abre o chat de contratação (mouse, toque ou teclado).
  const getCardActionProps = () => ({
    role: "button",
    tabIndex: 0,
    onClick: () => openSupportChat(HIRE_MESSAGE),
    onKeyDown: (event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        openSupportChat(HIRE_MESSAGE);
      }
    },
  });

  const addToBgElementsRef = (el) => {
    if (el && !bgElementsRef.current.includes(el)) {
      bgElementsRef.current.push(el);
    }
  };

  return (
    <div>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonicalUrl} />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        <meta name="twitter:url" content={canonicalUrl} />
        <meta name="twitter:image" content={logoUrl} />
        <script type="application/ld+json">{schemaLocalBusinessJson}</script>
        <script type="application/ld+json">{schemaWebsiteJson}</script>
        <script type="application/ld+json">{schemaWebPageJson}</script>
        <script type="application/ld+json">{schemaInternetServiceJson}</script>
      </Helmet>
      {isLoading && <Loader />}
      <HeaderContComponent />
      <HeaderComponent />
      <ModalIndicouGanhou
        show={showIndicouGanhouModal}
        onHide={() => setShowIndicouGanhouModal(false)}
        currentPanel={currentPanel}
      />

      <main className="content">
        <div className="content-sub">
          <section className="home-hero" aria-labelledby="home-hero-title">
            {/* Título principal da página para Google e leitores de tela; o banner é imagem. */}
            <h1 id="home-hero-title" className="visually-hidden">
              Internet fibra óptica em Anápolis e região com a SETTE Fibra
            </h1>
            <div ref={carouselRef} className="hero-carousel">
              <Carousel
                style={{
                  marginTop: 50,
                  backgroundColor: "#0a0a0a",
                  width: "100%",
                }}
                activeIndex={index}
                onSelect={handleSelect}
              >
                {carousel.map((banner, bannerIndex) => {
                  const isFirstBanner = bannerIndex === 0;
                  const loadingBehavior = isFirstBanner ? "eager" : "lazy";
                  const fetchPriority = isFirstBanner ? "high" : "auto";
                  const desktopSrc = banner.photo;
                  const mobileSrc = banner.photoMobile || banner.photo;
                  const fallbackAlt = getBannerAlt(banner, "desktop");
                  return (
                    <Carousel.Item
                      key={banner.id}
                      interval={7000}
                      onClick={() => {
                        if (banner.campanhaIndicouGanhou) {
                          setCurrentPanel(banner.panel);
                          setShowIndicouGanhouModal(true);
                        } else if (banner.link?.startsWith("#")) {
                          document
                            .getElementById(banner.link.slice(1))
                            ?.scrollIntoView({ behavior: "smooth" });
                        } else if (banner.link && !/whatsapp\.com|wa\.me/i.test(banner.link)) {
                          window.location.assign(banner.link);
                        } else {
                          // Banner sem link (ou com WhatsApp) abre o chat de contratação.
                          openSupportChat(HIRE_MESSAGE);
                        }
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <picture>
                        {mobileSrc && (
                          <source
                            media="(max-width: 768px)"
                            srcSet={mobileSrc}
                          />
                        )}
                        <img
                          alt={fallbackAlt}
                          src={desktopSrc || mobileSrc}
                          className="responsive-image"
                          loading={loadingBehavior}
                          decoding="async"
                          fetchpriority={fetchPriority}
                        />
                      </picture>
                    </Carousel.Item>
                  );
                })}
              </Carousel>
            </div>
          </section>

          <section className="plans-section" aria-labelledby="plans-title">
            <div id="plans" className="plan-container">
              <h2 ref={plansTitleRef} id="plans-title" className="plan-title">
                PLANOS{" "}
                <ColourfulText
                  text="EXTRAORDINÁRIOS"
                  gradient="linear-gradient(270deg, #e32285 28.23%, #9747ff 79.08%)"
                />{" "}
                PARA VOCÊ
              </h2>
              <div className="retangle-line"></div>
              <div ref={plansCardsRef} className="plan-cards">
                {panel1.map((card, cardIndex) => {
                  const isFeatured =
                    cardIndex === Math.floor(panel1.length / 2);
                  return (
                    <div className="plan-card-inner" key={card.id}>
                      <span
                        className={`plan-card ${
                          isFeatured ? "plan-card-featured" : ""
                        }`}
                        {...getCardActionProps()}
                      >
                        <img
                          alt={getCardAlt(
                            card,
                            "Plano de internet fibra em Anápolis",
                          )}
                          src={card.photo}
                          className="panel-card-img"
                          loading="lazy"
                          decoding="async"
                        />
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>

            <div id="lancamentos" className="plan-container">
              <h2 ref={lancamentosTitleRef} className="plan-title">
                CONFIRA{" "}
                <ColourfulText
                  text="SUPERLANÇAMENTOS"
                  gradient="linear-gradient(90deg, #FF0F7B, #F89B29)"
                />{" "}
                AQUI
              </h2>
              <div className="retangle-line"></div>

              <div ref={lancamentosCardsRef} className="plan-cards">
                {panel2.map((card) => (
                  <div className="plan-card-inner" key={card.id}>
                    <span
                      className="plan-card"
                      {...getCardActionProps()}
                    >
                      <img
                        alt={getCardAlt(
                          card,
                          "Oferta de internet fibra óptica em Anápolis",
                        )}
                        src={card.photo}
                        className="panel-card-img"
                        loading="lazy"
                        decoding="async"
                      />
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section
            className="advantages-section"
            aria-labelledby="advantage-title"
          >
            <div id="advantage" className="plan-container">
              <h4 className="plan-title">
                NOSSAS{" "}
              </h4>
              <h4
                ref={vantagensTitleRef}
                id="advantage-title"
                className="plan-title"
              >
                <ColourfulText
                  text="VANTAGENS"
                  gradient="linear-gradient(270deg, #29abe3 28.23%, #f9b041 79.08%)"
                />
              </h4>
              <div className="retangle-line2"></div>
              <div ref={vantagensCardsRef} className="plan-cards">
                {panel3.map((card) => (
                  <div className="plan-card-inner" key={card.id}>
                    <span
                      className="plan-card-vantagens"
                      {...getCardActionProps()}
                    >
                      <img
                        alt={getCardAlt(
                          card,
                          "Vantagem dos planos de internet da Sette Fibra",
                        )}
                        src={card.photo}
                        className="panel-card-img"
                        loading="lazy"
                        decoding="async"
                      />
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section
            id="cities"
            ref={citiesNetworkRef}
            className={`cities-network-section ${
              isCitiesNetworkPlaying ? "is-network-playing" : ""
            } ${isCitiesNetworkCanvasEnabled ? "is-network-canvas-active" : ""} ${
              selectedCitySlug !== CITY_NETWORK_HUB_SLUG
                ? "has-route-highlight"
                : ""
            } ${isCitiesNetworkCompact ? "is-network-compact" : ""}`.trim()}
            aria-labelledby="cities-network-title"
          >
            <div className="cities-network-shell">
              <div className="cities-network-header">
                <h2 className="plan-title cities-network-title">
                  CIDADES{" "}
                  <ColourfulText
                    text="CONECTADAS"
                    gradient="linear-gradient(90deg, #0061FF, #60EFFF)"
                  />{" "}
                  PELA SETTE
                </h2>
                <div className="retangle-line cities-network-line"></div>
                <p className="cities-network-subtitle">
                  A SETTE Fibra leva internet fibra óptica de alta velocidade em
                  Goiás, conectando cidades como Anápolis, Goiânia, Brasília e
                  região com estabilidade, baixa latência e performance ideal
                  para streaming, jogos online e empresas.
                </p>
                <p className="cities-network-seo-sr">
                  A SETTE Fibra é um provedor de internet fibra óptica em Goiás,
                  atendendo cidades como Anápolis, Goiânia, Brasília, Senador
                  Canedo, Nerópolis, Terezópolis de Goiás, Abadiânia, Campo
                  Limpo de Goiás, Planalmira e região. Oferecemos internet de
                  alta velocidade, baixa latência e conexão estável para
                  residências e empresas.
                </p>
              </div>

              <div
                ref={citiesNetworkMapRef}
                className="cities-network-map"
                role="img"
                aria-label="Mapa estilizado com cidades atendidas pela SETTE Fibra em Goiás conectadas por links de internet fibra óptica"
              >
                <canvas
                  ref={citiesNetworkCanvasRef}
                  className={`cities-network-canvas ${
                    isCitiesNetworkCanvasEnabled ? "is-active" : ""
                  }`}
                  aria-hidden="true"
                />
                <svg
                  className={`cities-network-svg ${
                    isCitiesNetworkCanvasEnabled ? "is-fallback-hidden" : ""
                  }`}
                  viewBox="0 0 100 100"
                  preserveAspectRatio="none"
                  aria-hidden="true"
                >
                  <defs>
                    <linearGradient
                      id="fiber-flow-gradient"
                      x1="0%"
                      y1="0%"
                      x2="100%"
                      y2="0%"
                    >
                      <stop offset="0%" stopColor="rgba(215, 250, 255, 0)" />
                      <stop
                        offset="45%"
                        stopColor="rgba(215, 250, 255, 0.85)"
                      />
                      <stop offset="55%" stopColor="#ffffff" />
                      <stop offset="100%" stopColor="rgba(215, 250, 255, 0)" />
                    </linearGradient>
                    <filter
                      id="fiber-soft-glow"
                      x="-60%"
                      y="-60%"
                      width="220%"
                      height="220%"
                    >
                      <feGaussianBlur stdDeviation="0.36" result="fiberBlur" />
                      <feMerge>
                        <feMergeNode in="fiberBlur" />
                        <feMergeNode in="SourceGraphic" />
                      </feMerge>
                    </filter>
                  </defs>
                  {cityNetworkLinks.map((connection, connectionIndex) => {
                    const fromNode = servedCityBySlug[connection.from];
                    const toNode = servedCityBySlug[connection.to];
                    if (!fromNode || !toNode) {
                      return null;
                    }
                    const connectionKey = `${connection.from}-${connection.to}`;
                    return (
                      <g
                        key={connectionKey}
                        className={`cities-network-fiber-group ${
                          selectedCityRouteConnectionKeySet.has(
                            getCityNetworkConnectionKey(
                              connection.from,
                              connection.to,
                            ),
                          )
                            ? "is-route-active"
                            : ""
                        } ${
                          selectedCitySlug !== CITY_NETWORK_HUB_SLUG &&
                          !selectedCityRouteConnectionKeySet.has(
                            getCityNetworkConnectionKey(
                              connection.from,
                              connection.to,
                            ),
                          )
                            ? "is-route-dimmed"
                            : ""
                        }`.trim()}
                      >
                        {fiberThreadProfiles.map(
                          (threadProfile, threadIndex) => {
                            if (
                              !citiesNetworkPerfProfile.visibleLaneIndexes.includes(
                                threadIndex,
                              )
                            ) {
                              return null;
                            }
                            const threadPath = buildFiberThreadPath(
                              fromNode,
                              toNode,
                              connection,
                              threadProfile,
                            );
                            const shouldAnimateFlow =
                              isCitiesNetworkPlaying &&
                              citiesNetworkPerfProfile.animatedLaneIndexes.includes(
                                threadIndex,
                              );
                            const shouldRenderLightParticle =
                              isCitiesNetworkPlaying &&
                              citiesNetworkPerfProfile.particleLaneIndexes.includes(
                                threadIndex,
                              );
                            const threadPathId = `fiber-path-${connectionKey}-${threadProfile.id}-${connectionIndex}`;
                            const activationDelay = `${
                              0.12 +
                              connectionIndex * 0.08 +
                              threadIndex * 0.035
                            }s`;
                            const connectDuration = `${
                              0.64 + ((threadIndex + connectionIndex) % 3) * 0.1
                            }s`;
                            const flowDuration = `${
                              threadProfile.flowDuration +
                              (connectionIndex % 3) * 0.14
                            }s`;
                            const flowDelay = `${
                              threadProfile.flowDelay +
                              (connectionIndex % 4) * 0.05
                            }s`;
                            const particleDuration = `${
                              4.2 + (connectionIndex % 4) * 0.45
                            }s`;
                            const particleDelay = `${-(
                              0.5 +
                              connectionIndex * 0.37
                            )}s`;
                            const particleRadius =
                              0.12 + (connectionIndex % 3) * 0.015;

                            const threadVars = {
                              "--fiber-activate-delay": activationDelay,
                              "--fiber-connect-duration": connectDuration,
                            };

                            return (
                              <g
                                key={`${connectionKey}-${threadProfile.id}`}
                                className="cities-network-thread-group"
                              >
                                <path
                                  className="cities-network-thread-glow"
                                  pathLength={1}
                                  d={threadPath}
                                  style={threadVars}
                                />
                                <path
                                  className="cities-network-thread"
                                  id={threadPathId}
                                  pathLength={1}
                                  d={threadPath}
                                  style={threadVars}
                                />
                                {shouldAnimateFlow && (
                                  <path
                                    className={`cities-network-thread-flow ${
                                      threadProfile.reverse ? "is-reverse" : ""
                                    }`}
                                    pathLength={1}
                                    d={threadPath}
                                    style={{
                                      ...threadVars,
                                      "--fiber-flow-duration": flowDuration,
                                      "--fiber-flow-delay": flowDelay,
                                      "--fiber-flow-dash":
                                        threadProfile.flowDash,
                                      "--fiber-flow-opacity":
                                        threadProfile.flowOpacity,
                                      "--fiber-flow-direction":
                                        threadProfile.reverse
                                          ? "reverse"
                                          : "normal",
                                    }}
                                  />
                                )}
                                {shouldRenderLightParticle && (
                                  <circle
                                    className="cities-network-thread-particle-lite"
                                    r={particleRadius}
                                  >
                                    <animateMotion
                                      dur={particleDuration}
                                      repeatCount="indefinite"
                                      begin={particleDelay}
                                    >
                                      <mpath href={`#${threadPathId}`} />
                                    </animateMotion>
                                  </circle>
                                )}
                              </g>
                            );
                          },
                        )}
                      </g>
                    );
                  })}
                </svg>

                {servedCities.map((node) => (
                  <div
                    key={node.slug}
                    className={`city-node ${
                      node.slug === "anapolis" ? "is-hub" : ""
                    } ${node.slug === selectedCitySlug ? "is-selected" : ""} ${
                      selectedCityRouteNodeSet.has(node.slug) &&
                      node.slug !== selectedCitySlug
                        ? "is-route-node"
                        : ""
                    }`}
                    role="button"
                    tabIndex={0}
                    aria-pressed={node.slug === selectedCitySlug}
                    style={{
                      "--x": `${node.x}%`,
                      "--y": `${node.y}%`,
                      "--label-x": `${node.labelX ?? 0}px`,
                      "--label-y": `${node.labelY ?? 0}px`,
                      "--label-x-mobile": `${node.labelXMobile ?? 0}px`,
                      "--label-y-mobile": `${node.labelYMobile ?? 0}px`,
                    }}
                    title={getCityNetworkSeoLabel(node)}
                    aria-label={getCityNetworkSeoLabel(node)}
                    onClick={() =>
                      handleCitiesNetworkSelectCity(node.slug, "map-point")
                    }
                    onKeyDown={(event) => {
                      if (event.key === "Enter" || event.key === " ") {
                        event.preventDefault();
                        handleCitiesNetworkSelectCity(node.slug, "map-point");
                      }
                    }}
                  >
                    <span className="city-node-core"></span>
                    <span className="city-node-label">{node.city.name}</span>
                  </div>
                ))}
              </div>

              {servedCityBySlug[selectedCitySlug] && (
                <p className="cities-network-selected" aria-live="polite">
                  <strong>{servedCityBySlug[selectedCitySlug].city.name}</strong>{" "}
                  tem internet fibra óptica SETTE. Toque em outra cidade no mapa
                  ou consulte a cobertura no seu endereço.
                </p>
              )}

              <div className="cities-network-footer">
                <div className="cities-network-stats">
                  <strong>
                    Mais de {servedCities.length} cidades com internet fibra
                    óptica ativa em Goiás
                  </strong>
                  <span>
                    Conectando residências e empresas com internet óptica,
                    estável e sem quedas.
                  </span>
                  <span>
                    Conexões monitoradas para manter velocidade consistente no
                    horário de pico.
                  </span>
                </div>
                <a
                  className="seo-cta-outline cities-network-cta"
                  href={whatsappLink}
                  onClick={(event) => {
                    event.preventDefault();
                    trackCitiesNetworkInteraction("cta_whatsapp_click", {
                      source: "cities-network-footer",
                    });
                    openSupportChat(HIRE_MESSAGE);
                  }}
                  aria-label="Consultar cobertura de internet fibra óptica pelo chat"
                  title="Consultar cobertura de internet fibra óptica pelo chat"
                >
                  Consultar cobertura
                </a>
              </div>
            </div>
          </section>

          <section id="app" className="app-section">
            <AppPromotionSection />
          </section>

          <section
            className="final-cta"
            aria-label="Chamada final para conversão"
          >
            <div className="final-cta-inner">
              <h4 style={{ color: "white" }}>
                Chega de internet que promete e não entrega.
              </h4>
              <p>
                Com a SETTE Fibra, você tem conexão estável, alta velocidade e
                atendimento humano. Contrate agora e sinta a diferença.
              </p>
              <div className="final-cta-actions">
                <a className="seo-cta" href="#plans">
                  Ver Planos
                </a>
                <a
                  className="seo-cta-outline"
                  href={whatsappLink}
                  target="_blank"
                  rel="noreferrer"
                >
                  Falar no WhatsApp
                </a>
              </div>
            </div>
          </section>

          <FooterComponent />
          <FloatingNotification />
        </div>
      </main>
      <div className="bg-layer">
        <div ref={addToBgElementsRef} className="bg-1"></div>
        <div ref={addToBgElementsRef} className="bg-2"></div>
        <div ref={addToBgElementsRef} className="bg-3"></div>
        <div ref={addToBgElementsRef} className="bg-4"></div>
        <div ref={addToBgElementsRef} className="bg-5"></div>
      </div>
    </div>
  );
}
